import { useMemo } from 'react';
import { Button } from 'antd';
import { Icon, Message } from '@docs/kd-d2c-components';
import { useNavigate } from 'react-router-dom';
import { eed_mario_icon_arrow_continue_line } from '@src/assets/icons';
import SchedulerIcon from '@src/assets/images/scheduler-card-icon.png';
import { SchedulerRunNotificationPayload } from '@src/types/scheduler-message';
import { decodeSchedulerPayload } from '@src/utils/scheduler-message';
import { getConversationDetailUrl } from '@src/utils/route';
import { kimBridge } from '@src/utils/kim-bridge';
import { isKim, isAndroid } from '@/utils/user-agent';
import './index.less';

interface Props {
  payload?: string;
}

export const SchedulerRunNotification = ({ payload }: Props) => {
  const navigate = useNavigate();
  const viewPayload = useMemo(
    () =>
      decodeSchedulerPayload<SchedulerRunNotificationPayload>(payload) ||
      ({} as SchedulerRunNotificationPayload),
    [payload],
  );
  const conversationId = (viewPayload?.conversation_id || '').trim();

  const onViewConversation = async () => {
    if (!conversationId) {
      Message.error({ message: '会话不存在' });
      return;
    }
    // iOS Kim 上从会话内部调用 kim.openMario({ type:1 }) 会导致当前 webview 被原生路由
    // 导回首页（而非打开新 webview），表现为「跳转了首页」。Android 不受影响，因为
    // Android 的 openMario 会打开独立新 webview。iOS 直接用 navigate() 客户端跳转。
    if (isAndroid && isKim) {
      try {
        await kimBridge.openMario({
          type: 1,
          url: getConversationDetailUrl(conversationId),
        });
        return;
      } catch {
        // Bridge 不可用时回退到普通跳转
        navigate(getConversationDetailUrl(conversationId, false));
        return;
      }
    }
    navigate(getConversationDetailUrl(conversationId, false));
  };

  return (
    <div className="scheduler-run-notification-card">
      <div className="scheduler-run-notification-header">
        <img
          src={SchedulerIcon}
          alt="scheduler-icon"
          className="scheduler-run-notification-icon"
        />
        <div className="scheduler-run-notification-main">
          <div className="scheduler-run-notification-title">
            {viewPayload.title || '定时任务'}
          </div>
          <div className="scheduler-run-notification-subtitle">定时任务</div>
        </div>
        <Button
          className="scheduler-run-notification-view-btn"
          type="primary"
          onClick={onViewConversation}
          disabled={!conversationId}
        >
          <span className="scheduler-run-notification-view-btn-content">
            <span>前去查看</span>
            <Icon size={16} icon={eed_mario_icon_arrow_continue_line} />
          </span>
        </Button>
      </div>
    </div>
  );
};
